/**
 * Instructor-selection toggle semantics for the booking flow.
 *
 * "All Instructors" is represented by an empty string (""). Clicking a
 * coach selects them; clicking the already-selected coach again clears the
 * selection back to "" (All Instructors) — the same state the dedicated
 * "All Instructors" card produces. The card's Select/Selected pill makes it
 * look like a toggle, so it must behave like one.
 *
 * Pure function so the interaction can be unit-tested without React.
 */
export function nextCoachSelection(currentId: string, clickedId: string): string {
  return currentId === clickedId ? "" : clickedId;
}
